import React, { createContext } from 'react';
import type { ReactNode } from 'react';
import { useServerSideEventContext } from './serverSideEvents/useServerSideEventContext';
import type { ServerSideEventContextValue } from './serverSideEvents/types';

export const SSEContext = createContext<ServerSideEventContextValue>(undefined);

type ServerSideEventProviderProps = {
    /** Application subtree sharing the authenticated organization's event stream. */
    children: ReactNode;
};

export const ServerSideEventProvider = ({ children }: ServerSideEventProviderProps) => {
    const contextValue = useServerSideEventContext();
    return <SSEContext.Provider value={contextValue}>{children}</SSEContext.Provider>;
};
